import { render, staticRenderFns } from "./adminQuestion.vue?vue&type=template&id=24f255a3&"
import script from "./adminQuestion.vue?vue&type=script&lang=js&"
export * from "./adminQuestion.vue?vue&type=script&lang=js&"
import style0 from "./adminQuestion.vue?vue&type=style&index=0&id=24f255a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports